module.exports = __webpack_public_path__ + "static/media/enhanced-grain-charred.8c48ae4c.jpg";